"use client"

/**
 * Opens the privacy policy in a popup window so the user can view it
 * without losing form data when they close it.
 */
export function PrivacyPolicyLink({ className = "" }: { className?: string }) {
  const openPrivacyPopup = () => {
    window.open(
      "/privacy",
      "privacy",
      "width=600,height=800,scrollbars=yes,resizable=yes"
    )
  }

  return (
    <button
      type="button"
      onClick={openPrivacyPopup}
      className={`underline hover:text-foreground cursor-pointer bg-transparent border-none p-0 font-inherit text-inherit ${className}`}
      aria-label="View ReliefHub privacy policy"
    >
      Privacy Policy
    </button>
  )
}
